import { Link, useParams } from "react-router-dom";
import backgroundImage from '../assets/LOGO.png';

import React, { useEffect, useState } from "react";
import { getGroupsForSuperUser } from "../api"; // Adjust path as needed

function AdminDashboardPage() {
    const { superUserId } = useParams();
    const superuserName = localStorage.getItem("username");
    const [mieters, setMieters] = useState([]);

    useEffect(() => {
        const fetchMieters = async () => {
            const token = localStorage.getItem("token");
            try {
                const response = await getGroupsForSuperUser(token);
                setMieters(response); // Adjust key if backend returns differently
            } catch (error) {
                console.error("Fehler beim Laden der Mieter:", error);
            }
        };

        fetchMieters();
    }, []);

    return (
<div style={{
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: 'contain', // or 'cover' depending on preference
  minHeight: '100vh',
  padding: '2rem',
  overflowY: 'auto'
}}>
            <h1>Wilkommen beim Liendlhof Admin Portal lieber {superuserName}</h1>
            <div className="navbar">
            <Link to={"pdfUploads"}>PDFs hochladen</Link>
            <Link to={"neuerMieter"}>Neuen Mieter hinzufügen</Link>
            <Link to={"sendMail"}>E-Mail verschicken</Link>
            </div>
            <div className="mt-4">
                <h2 className="text-lg font-semibold">📋 Deine Mieter</h2>
                {mieters.length > 0 ? (
  mieters.map((mieter) => (
    <div className="section-box"
      key={mieter.id}
    >
     <Link to={`${mieter.id}/${mieter.name}`}>
  {mieter.name}
</Link>


      <p className="text-gray-700 mt-2">
      <strong>Adresse:</strong> {mieter.street || "—"}, {mieter.postal_code || ""} {mieter.city || ""}
      </p>
      <p className="text-gray-700">
        <strong>Kontakt: </strong>{mieter.email || "—"}{mieter.handy_number ? ` | ${mieter.handy_number}` : ""}
      </p>
    </div>
  ))
) : (
  <p>Keine Mieter gefunden.</p>
)}
            </div>
        </div>
    );
}
 
export default AdminDashboardPage;
